import { useRef, useState } from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import AuthLayout from '@/components/AuthLayout'
import { useAuth } from '@/context/AuthContext'
import { api } from '@/lib/api'

export default function OTP() {
  const [codes, setCodes] = useState(['', '', '', '', '', ''])
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const inputRefs = useRef<(HTMLInputElement | null)[]>([])
  const navigate = useNavigate()
  const location = useLocation()
  const { verifyOtp } = useAuth()
  const email = (location.state as any)?.email || ''

  const handleChange = (index: number, value: string) => {
    if (value.length > 1) return
    const newCodes = [...codes]
    newCodes[index] = value
    setCodes(newCodes)
    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus()
    }
  }

  const handleKeyDown = (index: number, e: React.KeyboardEvent) => {
    if (e.key === 'Backspace' && !codes[index] && index > 0) {
      inputRefs.current[index - 1]?.focus()
    }
  }

  const handleSubmit = async () => {
    const code = codes.join('')
    if (code.length !== 6) {
      setError('6 оронтой код оруулна уу')
      return
    }
    setError('')
    setLoading(true)
    try {
      await verifyOtp(email, code)
      navigate('/')
    } catch (err: any) {
      setError(err.message || 'OTP баталгаажуулах үед алдаа гарлаа')
    } finally {
      setLoading(false)
    }
  }

  const handleResend = async () => {
    if (!email) return
    try {
      await api.auth.forgotPassword(email)
    } catch {
      // ignore
    }
  }

  return (
    <AuthLayout>
      <div className="w-full max-w-[550px] flex flex-col gap-8">
        <div className="flex flex-col gap-2">
          <h1 className="text-2xl font-bold text-black">Баталгаажуулах</h1>
          <p className="text-sm text-gray-600">
            Бид таны <span className="font-bold text-black">{email || 'info@gmail.com'}</span> хаяг руу 6 оронтой код илгээлээ.
          </p>
        </div>

        {error && (
          <div className="bg-red-50 text-red-600 text-sm rounded-xl px-4 py-3">{error}</div>
        )}

        <div className="flex flex-col gap-2">
          <label className="text-sm font-medium text-gray-700">OTP код оруулна уу.</label>
          <div className="flex gap-3">
            {codes.map((code, i) => (
              <input
                key={i}
                ref={el => { inputRefs.current[i] = el }}
                type="text"
                inputMode="numeric"
                maxLength={1}
                value={code}
                onChange={e => handleChange(i, e.target.value)}
                onKeyDown={e => handleKeyDown(i, e)}
                className="w-full aspect-square max-w-[64px] bg-white border border-gray-200 rounded-xl text-center text-2xl font-semibold text-gray-900 shadow-xs outline-none focus:border-primary-500 focus:ring-1 focus:ring-primary-500 transition"
              />
            ))}
          </div>
        </div>

        <button
          onClick={handleSubmit}
          disabled={loading}
          className="w-full bg-primary-500 text-white rounded-full px-[18px] py-3 text-base font-semibold shadow-xs hover:bg-primary-600 transition disabled:opacity-50"
        >
          {loading ? 'Шалгаж байна...' : 'Нэвтрэх'}
        </button>

        <button onClick={handleResend} className="text-sm font-medium text-primary-500 hover:text-primary-600 text-center">
          Код дахин илгээх
        </button>

        <Link
          to="/login"
          className="flex items-center justify-center gap-2 text-sm font-semibold text-gray-600 hover:text-gray-800"
        >
          <ArrowLeft className="size-5" />
          Буцах
        </Link>
      </div>
    </AuthLayout>
  )
}
